<template>
  <success
    :title="title"
    :type="type"
    :showBottomCloseBtn="false">
    <p v-if="failMsg" style="color:#888;">失败原因：{{ failMsg }}</p>
  </success>
</template>

<script>
import Success from '../components/Success'

export default {
  components: {
    Success
  },
  data() {
    return {
      // 状态（success、fail）
      status: ''
    }
  },
  computed: {
    // 标题
    title() {
      const titleConf = {
        success: '更新成功',
        fail: '更新失败'
      }
      return titleConf[this.status]
    },
    // 图标类型
    type() {
      const typeConf = {
        success: 'default',
        fail: 'error'
      }
      return typeConf[this.status]
    },
    // 失败信息
    failMsg() {
      return this.$route.query.failMsg
    }
  },
  mounted() {
    // 设置状态
    this.status = this.$route.params.status
  }
}
</script>
